module.exports = __webpack_public_path__ + "08060e888883fea32f80238e211461c5.pdf";